import React, { useEffect, useRef, useState } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../../Liracrypt/liracrypt";

const Angela1R = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [chartData, setChartData] = useState();
  useEffect(() => {
    if (props.api) {
      liracrypt.get(props.api, props.urlData).then(response => {
        if (!response.data.data[props.divId]) {
          return;
        }
        setChartData({ config: response.data.data[props.divId].config });
      }).catch(err => {
        console.log(err);
      })
    } else if (props.config) {
      setChartData({ config: props.config });
    }
  }, [props?.config]);
  // useEffect(() => {
  //   if (props.config) {
  //   }
  //   return () => {};
  // }, [props?.config]);
  // let dataBlocks = props.config.dataBlocks;
  // let headerBlocks = props.config.headerBlocks;
  // console.log("HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH");

  // console.log(headerBlocks);

  return (
    <div>
      {chartData?.config ? (
        <>
          <div id={props.divId} style={chartData.config.chartDiv.style}>
            <Row
              style={{
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
              }}
            >
              <Col
                style={{
                  width: "60%",
                }}
              >
                <div>
                  {/* <Row> */}
                  {chartData.config.headerBlocks.map((headerBlock) => {
                    return (
                      <Row style={{ width: "100%" }}>
                        <Col style={{ width: "100%" }}>
                          <div style={headerBlock.val.style}>
                            {`${headerBlock.val.text} `}
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                  {/* </Row> */}
                </div>
              </Col>
              <Col
                style={{
                  width: "30%",
                  justifyContent: "center",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <div>
                  {chartData.config.dataBlocks.map((dataBlock) => {
                    return (
                      <Row style={{ width: "100%" }}>
                        <Col style={{ width: "100%" }}>
                          <div style={dataBlock.val.style}>
                            {`${dataBlock.val.text} `}
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                </div>
              </Col>
            </Row>
          </div>
        </>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default Angela1R;
